angular.module('bmsApp.reports')
	.controller('ReportPlanningCtrl', [
		'$scope',
		'$q',
		'LicenseOptionsSvc',
		'ReportSvc',
		function ($scope,
				  $q,
				  LicenseOptionsSvc,
				  ReportSvc) {

			var self = this;

			function init() {
				self.loading = true;

				self.form = {
					options: {},
					validator: {
						config: {},
						api: {}
					},
					promise: undefined
				};

				self.selectedReport = {
					type: undefined,
					filters: {}
				};

				self.dateRangeConfig = angular.copy($scope.config.datePicker.range);
				angular.extend(self.dateRangeConfig, {
					options: {
						opens: 'right',
					},
				});

				$q.all([
					populateReportTypes()
						.then(function (options) {
							self.form.options.reportType = options;
						}),
					populateShowTypes()
						.then(function (options) {
							self.form.options.show = options;
						}),
					populateCleaningFrequency()
						.then(function (options) {
							self.form.options.showCleaningFrequency = options;
						}),
					LicenseOptionsSvc.license()
						.then(function (response) {
							self.form.options.license = response.data.options;
						})
				])
					.then(function () {
						populateYears();
						self.loading = false;
					});
			}

			function hasFilter(filterName) {
				return angular.isObject(self.selectedReport.type) && self.selectedReport.type.filters.indexOf(filterName) !== -1;
			}

			function populateReportTypes() {
				var deferred = $q.defer();
				deferred.resolve([
					{
						label: 'Daily Planning Report',
						value: 'daily',
						filters: [
							'dateRange',
							'license'
						]
					},
					{
						label: 'Weekly Planning Report',
						value: 'period',
						filters: [
							'year',
							'week',
							'license',
							'show',
							'showCleaningFrequency'
						]
					},
					{
						label: 'Monthly Planning Report',
						value: 'period',
						filters: [
							'year',
							'month',
							'license',
							'show',
							'showCleaningFrequency'
						]
					},
					{
						label: 'Quarterly Planning Report',
						value: 'period',
						filters: [
							'year',
							'quarter',
							'license',
							'show',
							'showCleaningFrequency'
						]
					}
				]);

				return deferred.promise;
			}

			function populateShowTypes() {
				var deferred = $q.defer();
				deferred.resolve([
					{
						value: 'all',
						label: 'All'
					},
					{
						value: 'preferred',
						label: 'Preferred Teams'
					},
					{
						value: 'scheduled',
						label: 'Scheduled Teams'
					},
				]);

				return deferred.promise;
			}
			function populateCleaningFrequency() {
				var deferred = $q.defer();
				deferred.resolve([
					{
						value: 'showCleaningFrequency',
						label: 'Cleaning Frequency'
					},
				]);

				return deferred.promise;
			}

			function populateYears() {
				self.form.options.year = [];
				var mDate = moment();
				for (var i = 1; i <= 3; i++) {
					self.form.options.year.push({
						value: mDate.format('YYYY'),
						label: mDate.format('YYYY')
					});
					mDate.add(1, 'year');
				}
			}

			function populateWeeks() {
				self.form.options.week = [];
				if (self.selectedReport.filters.year) {
					var mDate = moment()
						.year(self.selectedReport.filters.year)
						.isoWeek(1)
						.startOf('week');
					for (var i = 1; i <= mDate.isoWeeksInYear(); i++) {
						self.form.options.week.push({
							value: mDate.format('W'),
							label: mDate.format('D MMM [(Week ]W[)]')
						});
						mDate.add(1, 'week');
					}
				}
			}

			function populateMonths() {
				self.form.options.month = [];
				if (self.selectedReport.filters.year) {
					var mDate = moment()
						.year(self.selectedReport.filters.year)
						.month(0)
						.date(1);
					for (var i = 1; i <= 12; i++) {
						self.form.options.month.push({
							value: mDate.format('M'),
							label: mDate.format('MMMM')
						});
						mDate.add(1, 'month');
					}
				}
			}

			function populateQuarters() {
				self.form.options.quarter = [];
				if (self.selectedReport.filters.year) {
					for (var i = 1; i <= 4; i++) {
						self.form.options.quarter.push({
							value: i,
							label: 'Q' + i
						});
					}
				}
			}

			function onReportTypeChanged() {
				self.selectedReport.filters = {};
				if (angular.isObject(self.selectedReport.type)) {
					if (self.selectedReport.type.filters.indexOf('year') !== -1) {
						populateYears();
					}
					if (self.selectedReport.type.filters.indexOf('show') !== -1) {
						self.selectedReport.filters.show = 'all';
					}
					if (self.selectedReport.type.filters.indexOf('showCleaningFrequency') !== -1) {
						self.selectedReport.filters.showCleaningFrequency = false;
					}
					
				}
			}

			function onYearChanged() {
				if (self.selectedReport.type.filters.indexOf('week') !== -1) {
					populateWeeks();
				}
				if (self.selectedReport.type.filters.indexOf('month') !== -1) {
					populateMonths();
				}
				if (self.selectedReport.type.filters.indexOf('quarter') !== -1) {
					populateQuarters();
				}
			}

			function submit() {
				if (self.form.validator.api.valid()) {
					var params = angular.copy(self.selectedReport.filters);
					if (angular.isObject(params.license)) {
						// only submit what's necessary from the licence
						params.license = {
							id: params.license.id
						};
					}

					if (angular.isDefined(params.dateRange)) {
						params.date_from = params.dateRange.startDate;
						params.date_to = params.dateRange.endDate;
					}

					if (self.selectedReport.type.value === 'daily') {
						ReportSvc.openDailyPlanningReport(params);
					}
					else if (self.selectedReport.type.value === 'period') {
						if (self.selectedReport.type.filters.indexOf('week') !== -1) {
							params.period_type = 'week';
						}
						else if (self.selectedReport.type.filters.indexOf('month') !== -1) {
							params.period_type = 'month';
						}
						else if (self.selectedReport.type.filters.indexOf('quarter') !== -1) {
							params.period_type = 'quarter';
						}
						ReportSvc.openPeriodPlanningReport(params);
					}
					else {
						console.info('Invalid period type');
					}
				}
			}

			self.methods = {
				init: init,
				hasFilter: hasFilter,
				submit: submit
			};

			self.handlers = {
				onReportTypeChanged: onReportTypeChanged,
				onYearChanged: onYearChanged
			};

		}
	]);
